import React, { useState } from "react";
import { Link } from "react-router-dom";
import AkkhorLayout from "../layout/akkhor";

// Trang hướng dẫn nghiệp vụ Trình ký online (Tờ trình) — V2.
// Ảnh minh họa chụp từ luồng thật, lưu tại public/huong-dan-to-trinh/.

const statusList = [
  { name: "Đang chạy / Chưa hoàn tất", desc: "Tờ trình đang luân chuyển qua các bước ký.", color: "#f0a500" },
  { name: "Đã được duyệt", desc: "Tất cả các bước đã ký xong, hệ thống tạo ra file có dấu và trang chữ ký.", color: "#28a745" },
  { name: "Đã hủy", desc: "Tờ trình bị hủy bỏ, dừng luân chuyển.", color: "#dc3545" },
  { name: "Bản nháp / Bị trả về", desc: "Tờ trình đang ở người tạo để bổ sung hoặc chờ gửi lại.", color: "#6c757d" },
];

const actionList = [
  { code: "Ký duyệt", desc: "Đồng ý bước hiện tại. Nếu là bước cuối, tờ trình hoàn tất và có file đã ký.", color: "#28a745" },
  { code: "Xin ý kiến", desc: "Nêu ý kiến và được tính là đã ký để tờ trình đi tiếp (bắt buộc nhập ý kiến).", color: "#6c757d" },
  { code: "Y/c bổ sung", desc: "Gửi tờ trình về người tạo để bổ sung; sau khi họ gửi lại sẽ quay đúng bước đang chờ.", color: "#17a2b8" },
  { code: "Trả về", desc: "Gửi tờ trình về người tạo và bỏ toàn bộ chữ ký để duyệt lại từ đầu (bắt buộc nhập lý do).", color: "#f0a500" },
  { code: "Hủy bỏ", desc: "Hủy tờ trình.", color: "#dc3545" },
];

const chucNang = [
  { group: "Danh sách tờ trình", link: "/workflow_walking", desc: "Xem, lọc, thống kê nhanh và mở chi tiết tờ trình do mình tạo hoặc mình tham gia." },
  { group: "Tạo tờ trình", link: "/add-workflow_walking", desc: "Tạo tờ trình mới, chọn loại và dựng quy trình phê duyệt." },
  { group: "Phân loại tờ trình", link: "/workflow_type", desc: "Cấu hình các loại tờ trình và các bước ký mặc định theo phòng ban." },
];

const vaiTro = [
  { role: "Người tạo (tác giả)", work: "Tạo tờ trình, dựng quy trình, tải file lên, bổ sung khi bị yêu cầu, gửi lại khi bị trả về." },
  { role: "Người ký / phê duyệt", work: "Ký duyệt, xin ý kiến, yêu cầu bổ sung, trả về hoặc hủy ở đúng bước của mình." },
  { role: "Người quản trị cấu hình", work: "Tạo loại tờ trình, cấu hình bước ký mặc định theo phòng ban." },
];

// Các quy trình nghiệp vụ - hiển thị dạng accordion
const quyTrinh = [
  {
    id: "qtA",
    title: "Quy trình A: Tạo mẫu (loại) tờ trình — Phân loại tờ trình",
    intro:
      "Dành cho người quản trị. Mỗi loại tờ trình là một mẫu quy trình phê duyệt dựng sẵn, để người dùng chỉ cần chọn khi tạo tờ trình. Xem và quản lý tại Phân loại tờ trình.",
    links: [{ label: "Phân loại tờ trình", to: "/workflow_type" }],
    steps: [
      "Vào Tờ trình > Phân loại tờ trình để xem danh sách các loại đã có.",
      "① Bấm Thêm mới để tạo một loại tờ trình mới.",
      "② Cột Tiến trình cho biết các bước ký của từng loại; có thể mở để Sửa.",
      "③ Bấm Sao chép để nhân bản một loại có sẵn rồi chỉnh lại cho nhanh.",
    ],
    image: "/huong-dan-to-trinh/12-danhsach-loai.png",
    caption: "Danh sách loại tờ trình: ① Thêm mới, ② cột Tiến trình (các bước), ③ Sao chép.",
  },
  {
    id: "qtB",
    title: "Quy trình B: Nhập thông tin loại tờ trình",
    intro: "Đặt tên loại và phạm vi áp dụng cho loại tờ trình.",
    links: [],
    steps: [
      "① Nhập Tên loại tờ trình (ví dụ: Tờ trình mua sắm).",
      "② Chọn phòng ban áp dụng — để trống nghĩa là dùng chung cho tất cả.",
      "③ Chọn Trạng thái Hoạt động để loại này hiện ra khi người dùng tạo tờ trình.",
      "④ Bấm Lưu loại tờ trình.",
    ],
    image: "/huong-dan-to-trinh/13-them-loai.png",
    caption: "Màn Thêm mới loại tờ trình: ① Tên loại, ② Phòng ban áp dụng, ③ Trạng thái, ④ Lưu.",
    note: "Phải Lưu loại tờ trình trước, sau đó mở lại (Sửa) mới thêm được các tiến trình (bước ký).",
  },
  {
    id: "qtC",
    title: "Quy trình C: Thêm các tiến trình (bước ký) cho loại",
    intro: "Sau khi lưu loại, mở lại để dựng các bước ký theo thứ tự.",
    links: [],
    steps: [
      "Mở loại tờ trình cần cấu hình (bấm Sửa ở danh sách).",
      "① Bấm Thêm tiến trình để thêm một bước ký.",
      "② Bảng Các tiến trình liệt kê các bước theo thứ tự, phòng ban và người ký; có thể sửa, xóa hoặc đổi thứ tự bằng mũi tên lên/xuống.",
      "Bấm Lưu loại tờ trình để lưu toàn bộ.",
    ],
    image: "/huong-dan-to-trinh/14-cac-tien-trinh.png",
    caption: "Cấu hình bước ký của loại: ① Thêm tiến trình, ② bảng Các tiến trình.",
  },
  {
    id: "qtD",
    title: "Quy trình D: Khai báo một tiến trình",
    intro: "Nhập thông tin cho từng bước ký trong loại tờ trình.",
    links: [],
    steps: [
      "① Nhập Tên tiến trình (ví dụ: Phòng Tài chính).",
      "② Chọn phòng ban của bước này (hệ thống sẽ lấy người ký mặc định của phòng).",
      "③ Hoặc chỉ định Người ký là một cá nhân cụ thể.",
      "④ Chọn Ký nháy nếu bước này chỉ ký nháy (ký phụ).",
      "⑤ Bấm Lưu tiến trình.",
    ],
    image: "/huong-dan-to-trinh/15-them-tien-trinh.png",
    caption: "Khai báo tiến trình: ① Tên, ② Phòng ban, ③ Người ký, ④ Ký nháy, ⑤ Lưu tiến trình.",
    note: "Một tiến trình có thể áp dụng cho nhiều đơn vị; bấm dấu + để thêm đơn vị vào cùng một bước.",
  },
  {
    id: "qt1",
    title: "Quy trình 1: Tạo tờ trình & điền thông tin",
    intro: "Tạo một tờ trình mới, điền thông tin cơ bản và tải file nội dung.",
    links: [{ label: "Tạo tờ trình", to: "/add-workflow_walking" }],
    steps: [
      "Vào Tờ trình > Danh sách tờ trình > bấm Thêm mới (hoặc menu Tạo tờ trình).",
      "① Nhập Tên tờ trình.",
      "② Nhập Ghi chú (nếu dùng tài khoản phòng ban, ghi kèm mã nhân viên của người trình).",
      "③ Nhập Số tờ trình.",
      "④ Bấm Chọn ở ô Loại tờ trình để chọn loại.",
      "⑤ Bấm Tải file lên để đưa file tờ trình (định dạng PDF) lên (bắt buộc). Có thể thêm Tài liệu tham khảo (không bắt buộc).",
    ],
    image: "/huong-dan-to-trinh/01-dien-thong-tin.png",
    caption: "Màn Thêm mới tờ trình: ① Tên, ② Ghi chú, ③ Số tờ trình, ④ Chọn loại, ⑤ Tải file lên.",
  },
  {
    id: "qt2",
    title: "Quy trình 2: Chọn loại tờ trình",
    intro: "Chọn loại tờ trình để hệ thống dựng sẵn quy trình phê duyệt, hoặc chọn loại thủ công để tự dựng.",
    links: [],
    steps: [
      "Ở ô Loại tờ trình, bấm Chọn.",
      "① Chọn một loại trong danh sách. Có thể lọc Sử dụng chung hoặc theo phòng ban, và tìm kiếm theo tên.",
      "Với loại thông thường: quy trình phê duyệt được dựng tự động theo cấu hình.",
      "Chọn Tờ trình thủ công nếu muốn tự tạo các bước ký (xem Quy trình 3).",
    ],
    image: "/huong-dan-to-trinh/02-chon-loai.png",
    caption: "Modal Chọn loại tờ trình: ① danh sách loại (bấm để chọn).",
  },
  {
    id: "qt3",
    title: "Quy trình 3: Dựng quy trình thủ công",
    intro: "Khi chọn loại Tờ trình thủ công, tự thêm các tiến trình (bước ký) và chọn người ký cho từng bước.",
    links: [],
    steps: [
      "Sau khi chọn Tờ trình thủ công, hộp Thêm loại tờ trình thủ công hiện ra.",
      "① Bấm ô Thêm tiến trình để thêm một bước ký. Bấm nhiều lần để có nhiều bước.",
      "Trong mỗi tiến trình: bấm Chọn để tìm nhân sự, rồi bấm Thêm người để đưa vào bước (một bước có thể có nhiều người).",
      "Có thể sửa tên tiến trình và xóa người/tiến trình bằng nút tương ứng.",
      "Bấm Lưu lại để đưa quy trình vào tờ trình.",
    ],
    image: "/huong-dan-to-trinh/04-them-tien-trinh.png",
    caption: "Hộp dựng quy trình thủ công: ① Tiến trình 1 (Nguyễn Xuân Phong), ② Tiến trình 2 (App Admin), ③ Lưu lại.",
    note: "Chọn người xong PHẢI bấm Thêm người thì người đó mới vào tiến trình (do một bước cho phép nhiều người ký).",
  },
  {
    id: "qt4",
    title: "Quy trình 4: Kiểm tra quy trình & gửi tờ trình",
    intro: "Xem lại quy trình phê duyệt đã dựng rồi gửi tờ trình đi.",
    links: [],
    steps: [
      "Sau khi Lưu lại, khu Quy trình phê duyệt hiển thị các bước theo thứ tự.",
      "① Bước 1 và ② Bước 2 hiển thị người ký và trạng thái Chờ ký.",
      "③ Bấm Gửi tờ trình để tạo. Hệ thống báo Tạo tờ trình thành công và chuyển sang màn chi tiết.",
    ],
    image: "/huong-dan-to-trinh/05-quy-trinh-da-luu.png",
    caption: "Quy trình đã lưu: ① Tiến trình 1, ② Tiến trình 2, ③ nút Gửi tờ trình.",
    note: "Bước 1 nếu chỉ có đúng người tạo thì hệ thống tự động ký qua và chuyển sang bước kế tiếp.",
  },
  {
    id: "qt5",
    title: "Quy trình 5: Người ký thao tác tại bước của mình",
    intro: "Người đang ở bước hiện tại mở tờ trình và thực hiện thao tác ký.",
    links: [{ label: "Danh sách tờ trình", to: "/workflow_walking" }],
    steps: [
      "Người ký nhận thông báo (badge số ở menu Tờ trình) và mở tờ trình cần xử lý.",
      "① Chỉ người ở bước hiện tại mới thấy cụm nút thao tác: Ký duyệt, Xin ý kiến, Y/c bổ sung, Trả về, Hủy bỏ (và Thêm người ký).",
      "② Các bước sau chỉ hiển thị Chờ ký — chưa đến lượt nên không có nút thao tác.",
      "③ Khung Hoạt động ghi lại toàn bộ lịch sử: ai tạo, ai ký, ai trả về, kèm thời gian và ý kiến.",
      "Nhập ý kiến (bắt buộc với Xin ý kiến / Y/c bổ sung / Trả về) rồi bấm nút tương ứng.",
    ],
    image: "/huong-dan-to-trinh/08-nut-ky.png",
    caption: "Màn phê duyệt (đang là người ký bước 1): ① cụm nút ký, ② bước sau đang Chờ ký, ③ khung Hoạt động.",
    note: "Chỉ đúng người, đúng bước, đúng lượt mới ký được — không ai ký thay người khác được.",
  },
  {
    id: "qt6",
    title: "Quy trình 6: Ký duyệt và chuyển bước",
    intro: "Sau khi ký duyệt, tờ trình tự chuyển sang bước kế tiếp.",
    links: [],
    steps: [
      "Ở bước của mình, nhập ý kiến (nếu cần) rồi bấm Ký duyệt.",
      "Hệ thống báo Thao tác thành công.",
      "Bước vừa ký chuyển sang trạng thái Đã duyệt (kèm thời gian và ý kiến), tờ trình tự chuyển sang người ký kế tiếp.",
    ],
    image: "/huong-dan-to-trinh/09-ky-buoc-1.png",
    caption: "Sau khi Ký duyệt: bước 1 chuyển Đã duyệt, khung Hoạt động cập nhật.",
  },
  {
    id: "qt7",
    title: "Quy trình 7: Đăng nhập hộ tài khoản khác (chỉ Admin)",
    intro: "Tài khoản quản trị có thể đăng nhập vào tài khoản người dùng khác để hỗ trợ/kiểm tra.",
    links: [{ label: "Danh sách nhân sự", to: "/list-users" }],
    steps: [
      "Vào menu Nhân sự > Danh sách nhân sự.",
      "Tìm nhân sự theo Tên / Mã nhân viên / Email rồi bấm Lọc.",
      "② Bấm nút Đăng nhập ở dòng nhân sự tương ứng và xác nhận.",
      "Hệ thống chuyển sang phiên làm việc của tài khoản đó (dùng để xem đúng nút ký của người ký khi hỗ trợ).",
    ],
    image: "/huong-dan-to-trinh/07-nhan-su-login-as.png",
    caption: "Danh sách nhân sự: ① menu Nhân sự, ② nút Đăng nhập (đăng nhập hộ).",
    note: "Chỉ tài khoản có quyền quản trị mới thấy và dùng được nút Đăng nhập này.",
  },
  {
    id: "qt8",
    title: "Quy trình 8: Hoàn tất & xem tờ trình đã ký",
    intro: "Khi bước cuối ký duyệt, tờ trình hoàn tất và hệ thống tạo ra file có dấu và trang chữ ký.",
    links: [],
    steps: [
      "Người ký bước cuối bấm Ký duyệt, tờ trình chuyển sang Đã được duyệt.",
      "① Mục Tờ trình đã được duyệt hiển thị file đã ký — đã có dấu, mã tra cứu và trang chữ ký của những người duyệt.",
      "② Con dấu Hồ sơ trực tuyến - Đã duyệt hiển thị trên màn hình.",
      "③ Trạng thái tờ trình là Đã được duyệt.",
    ],
    image: "/huong-dan-to-trinh/11-file-da-ky.png",
    caption: "Tờ trình đã hoàn tất: ① file đã ký, ② con dấu Đã duyệt, ③ trạng thái Đã được duyệt.",
    note: "Bấm vào file để xem hoặc tải bản đã ký (có dấu và trang chữ ký).",
  },
  {
    id: "qt9",
    title: "Quy trình 9: Bổ sung & gửi lại khi bị Y/c bổ sung hoặc Trả về",
    intro: "Khi tờ trình bị Y/c bổ sung hoặc Trả về, tờ trình quay về người tạo.",
    links: [],
    steps: [
      "Người tạo mở tờ trình (đang chờ bổ sung).",
      "Chỉnh sửa thông tin / thay file nếu cần.",
      "Bấm Gửi tờ trình để gửi lại. Với Y/c bổ sung: quay đúng bước đang chờ. Với Trả về: quay lại từ bước đầu.",
    ],
    note: "Khi Trả về, toàn bộ chữ ký của tờ trình được bỏ đi để duyệt lại từ bước 1.",
  },
];

const faqList = [
  {
    q: "Tôi tạo tờ trình xong nhưng người ký bước 1 không thấy để ký?",
    a: "Kiểm tra lại quy trình phê duyệt: người ký phải được thêm vào đúng bước (nhớ bấm Thêm người). Nếu bước 1 chỉ có chính bạn, hệ thống tự ký qua và chuyển sang bước sau. Người ký cũng cần đăng nhập đúng tài khoản của mình.",
  },
  {
    q: "Vì sao tôi mở tờ trình nhưng không thấy nút Ký duyệt?",
    a: "Nút ký chỉ hiện với người đang ở bước hiện tại. Nếu chưa đến lượt bạn (bước của bạn ở phía sau) hoặc bạn không thuộc bước nào, tờ trình chỉ hiển thị để xem.",
  },
  {
    q: "Chọn nhầm người ký thì sửa thế nào?",
    a: "Khi đang dựng quy trình (lúc tạo), bấm dấu × bên cạnh tên để xóa người, rồi chọn lại. Nếu tờ trình đã gửi đi, dùng nút Thêm người ký ở bước tương ứng, hoặc yêu cầu người có quyền điều chỉnh.",
  },
  {
    q: "Tờ trình đã tạo rồi có thêm hoặc chèn thêm tiến trình (bước ký) vào được không?",
    a: "Không. Sau khi đã bấm tạo tờ trình, quy trình đã được chốt theo mẫu; nếu thêm hoặc chèn tiến trình khác vào giữa sẽ làm sai mẫu tờ trình. Trường hợp cần thay đổi các bước, bạn phải Hủy bỏ tờ trình và tạo lại tờ trình mới với quy trình đúng. (Việc thêm/chèn bước chỉ làm được ở mẫu — mục Phân loại tờ trình — trước khi tạo.)",
  },
  {
    q: "Khác nhau giữa Y/c bổ sung và Trả về là gì?",
    a: "Y/c bổ sung: gửi về người tạo để bổ sung, sau khi gửi lại sẽ quay đúng bước đang chờ (các chữ ký trước vẫn giữ). Trả về: gửi về người tạo và bỏ toàn bộ chữ ký, phải duyệt lại từ bước đầu.",
  },
  {
    q: "Bấm Xin ý kiến có được tính là đã duyệt không?",
    a: "Có. Xin ý kiến được tính là đã ký để tờ trình đi tiếp, nhưng bắt buộc bạn phải nhập ý kiến trước khi bấm.",
  },
  {
    q: "Tờ trình bị trả về, tôi sửa lại và gửi thế nào?",
    a: "Mở tờ trình đang chờ bổ sung, chỉnh sửa thông tin hoặc thay file, rồi bấm Gửi tờ trình để gửi lại vào quy trình.",
  },
  {
    q: "File đã ký nằm ở đâu, tải về kiểu gì?",
    a: "Khi tờ trình Đã được duyệt, mở tờ trình, mục Tờ trình đã được duyệt hiển thị file đã ký (có dấu và trang chữ ký). Bấm vào file để xem hoặc tải về.",
  },
  {
    q: "Lỡ tạo sai tờ trình thì hủy được không?",
    a: "Được. Người có quyền hủy (hoặc người tạo trong trường hợp cho phép) bấm Hủy bỏ tờ trình. Tờ trình chuyển sang trạng thái Đã hủy và dừng luân chuyển.",
  },
];

export default function HuongDanToTrinh() {
  const [open, setOpen] = useState("qtA");
  const [openFaq, setOpenFaq] = useState("");
  const toggle = (id) => setOpen(open === id ? "" : id);
  const toggleFaq = (i) => setOpenFaq(openFaq === i ? "" : i);

  return (
    <AkkhorLayout idrole="workflow_walking">
      <div className="breadcrumbs-area">
        <ul>
          <li>
            <Link to="/">Trang chủ</Link>
          </li>
          <li>Hướng dẫn nghiệp vụ tờ trình</li>
        </ul>
      </div>

      {/* 1. Tổng quan */}
      <div className="card height-auto mb-3">
        <div className="card-body">
          <div className="heading-layout1">
            <div className="item-title">
              <h3 className="mb-0">
                <span className="fas fa-file-signature mr-2" style={{ color: "#f0a500" }} />
                Hướng dẫn nghiệp vụ tờ trình (Trình ký online)
              </h3>
            </div>
          </div>
          <p className="mb-2">
            Module <b>Trình ký online</b> cho phép tạo <b>tờ trình</b> kèm file nội dung, dựng <b>quy trình phê duyệt</b>{" "}
            nhiều bước, luân chuyển qua từng người để ký duyệt / xin ý kiến / yêu cầu bổ sung / trả về / hủy. Khi
            duyệt xong, hệ thống tự đóng dấu, thêm trang chữ ký và tạo ra <b>file đã ký</b>.
          </p>
          <p className="mb-0" style={{ color: "#888" }}>
            Trong menu, module nằm ở mục <b>Tờ trình</b>.
          </p>
        </div>
      </div>

      {/* 2. Chức năng chính */}
      <div className="card height-auto mb-3">
        <div className="card-body">
          <h4 className="mb-3">
            <span className="fas fa-th-large mr-2" style={{ color: "#17a2b8" }} />
            1. Chức năng chính
          </h4>
          <div className="row">
            {chucNang.map((c, i) => (
              <div className="col-12 col-md-6 col-lg-4 mb-3" key={i}>
                <div style={{ border: "1px solid #eee", borderRadius: 8, padding: "12px 14px", height: "100%" }}>
                  <Link to={c.link} style={{ fontWeight: 600, fontSize: 15 }}>
                    <span className="fas fa-arrow-circle-right mr-1" />
                    {c.group}
                  </Link>
                  <div style={{ color: "#777", fontSize: 13, marginTop: 6 }}>{c.desc}</div>
                </div>
              </div>
            ))}
          </div>
        </div>
      </div>

      {/* 3. Vai trò nghiệp vụ */}
      <div className="card height-auto mb-3">
        <div className="card-body">
          <h4 className="mb-3">
            <span className="fas fa-users mr-2" style={{ color: "#28a745" }} />
            2. Vai trò nghiệp vụ
          </h4>
          <table className="table table-bordered mb-0" style={{ fontSize: 13 }}>
            <thead>
              <tr>
                <th style={{ width: 240 }}>Vai trò</th>
                <th>Việc thường làm</th>
              </tr>
            </thead>
            <tbody>
              {vaiTro.map((v, i) => (
                <tr key={i}>
                  <td style={{ fontWeight: 600 }}>{v.role}</td>
                  <td>{v.work}</td>
                </tr>
              ))}
            </tbody>
          </table>
        </div>
      </div>

      {/* 4. Trạng thái tờ trình */}
      <div className="card height-auto mb-3">
        <div className="card-body">
          <h4 className="mb-3">
            <span className="fas fa-tasks mr-2" style={{ color: "#007bff" }} />
            3. Trạng thái tờ trình
          </h4>
          <div className="row">
            {statusList.map((s, i) => (
              <div className="col-12 col-md-6 col-lg-3 mb-3" key={i}>
                <div style={{ borderLeft: `4px solid ${s.color}`, background: "#fafafa", borderRadius: 6, padding: "10px 12px", height: "100%" }}>
                  <div style={{ display: "flex", alignItems: "center", marginBottom: 4 }}>
                    <span style={{ background: s.color, borderRadius: "50%", width: 12, height: 12, display: "inline-block", marginRight: 8, flexShrink: 0 }} />
                    <span style={{ fontWeight: 600, fontSize: 14 }}>{s.name}</span>
                  </div>
                  <div style={{ color: "#777", fontSize: 12.5 }}>{s.desc}</div>
                </div>
              </div>
            ))}
          </div>
        </div>
      </div>

      {/* 5. Các thao tác ký */}
      <div className="card height-auto mb-3">
        <div className="card-body">
          <h4 className="mb-3">
            <span className="fas fa-pen-nib mr-2" style={{ color: "#e83e8c" }} />
            4. Các thao tác ký tại một bước
          </h4>
          <div className="row">
            {actionList.map((a, i) => (
              <div className="col-12 col-md-6 col-lg-4 mb-3" key={i}>
                <div style={{ border: "1px solid #eee", borderLeft: `4px solid ${a.color}`, borderRadius: 6, padding: "10px 12px", height: "100%" }}>
                  <div style={{ fontWeight: 700, color: a.color, fontSize: 14 }}>{a.code}</div>
                  <div style={{ color: "#777", fontSize: 12.5, marginTop: 3 }}>{a.desc}</div>
                </div>
              </div>
            ))}
          </div>
        </div>
      </div>

      {/* 6. Các quy trình - accordion */}
      <div className="card height-auto mb-3">
        <div className="card-body">
          <h4 className="mb-3">
            <span className="fas fa-list-ol mr-2" style={{ color: "#6f42c1" }} />
            5. Các quy trình nghiệp vụ
          </h4>
          {quyTrinh.map((qt) => {
            const isOpen = open === qt.id;
            return (
              <div key={qt.id} style={{ border: "1px solid #eee", borderRadius: 8, marginBottom: 10, overflow: "hidden" }}>
                <div
                  onClick={() => toggle(qt.id)}
                  style={{ cursor: "pointer", padding: "12px 15px", background: isOpen ? "#f0f4ff" : "#f7f7f7", display: "flex", alignItems: "center", fontWeight: 600 }}
                >
                  <span className={isOpen ? "fas fa-chevron-down mr-2" : "fas fa-chevron-right mr-2"} style={{ color: "#6f42c1", fontSize: 13 }} />
                  {qt.title}
                </div>
                {isOpen && (
                  <div style={{ padding: "14px 18px" }}>
                    <p style={{ color: "#666", fontSize: 13.5 }}>{qt.intro}</p>
                    {qt.links && qt.links.length > 0 && (
                      <div style={{ marginBottom: 10 }}>
                        {qt.links.map((l, i) => (
                          <Link key={i} to={l.to} className="btn-fill-sm btn-gradient-yellow btn-hover-bluedark mr-2" style={{ fontSize: 12.5 }}>
                            <span className="fas fa-external-link-alt mr-1" />
                            {l.label}
                          </Link>
                        ))}
                      </div>
                    )}
                    <ol style={{ paddingLeft: 18, fontSize: 13.5, lineHeight: 1.7 }}>
                      {qt.steps.map((s, i) => (
                        <li key={i}>{s}</li>
                      ))}
                    </ol>
                    {qt.image && (
                      <figure style={{ margin: "12px 0 4px" }}>
                        <a href={qt.image} target="_blank" rel="noopener noreferrer">
                          <img
                            src={qt.image}
                            alt={qt.caption || qt.title}
                            style={{ width: "100%", maxWidth: 1000, border: "1px solid #e3e3e3", borderRadius: 8, boxShadow: "0 2px 8px rgba(0,0,0,.08)", display: "block" }}
                          />
                        </a>
                        {qt.caption && (
                          <figcaption style={{ fontSize: 12.5, color: "#888", marginTop: 6, fontStyle: "italic" }}>
                            <span className="fas fa-camera mr-1" />
                            {qt.caption} (Bấm ảnh để xem lớn.)
                          </figcaption>
                        )}
                      </figure>
                    )}
                    {qt.note && (
                      <div style={{ background: "#fff8e1", border: "1px solid #ffe0a3", borderRadius: 6, padding: "8px 12px", fontSize: 12.5, color: "#8a6d00", marginTop: 8 }}>
                        <span className="fas fa-lightbulb mr-1" />
                        {qt.note}
                      </div>
                    )}
                  </div>
                )}
              </div>
            );
          })}
        </div>
      </div>

      {/* 7. Lưu ý */}
      <div className="card height-auto mb-3">
        <div className="card-body">
          <h4 className="mb-3">
            <span className="fas fa-info-circle mr-2" style={{ color: "#6c757d" }} />
            6. Lưu ý khi sử dụng
          </h4>
          <ul style={{ fontSize: 13.5, lineHeight: 1.9, color: "#555", marginBottom: 0 }}>
            <li>File tờ trình chỉ nhận định dạng PDF.</li>
            <li>Chọn người vào tiến trình thủ công phải bấm <b>Thêm người</b> mới có hiệu lực.</li>
            <li>Chỉ đúng người, đúng bước, đúng lượt mới thao tác ký được.</li>
            <li>Xin ý kiến / Y/c bổ sung / Trả về bắt buộc nhập ý kiến.</li>
            <li>File đã ký được tạo ra sau khi tờ trình hoàn tất; bấm vào file để xem hoặc tải về.</li>
          </ul>
        </div>
      </div>

      {/* 7. Câu hỏi thường gặp */}
      <div className="card height-auto mb-3">
        <div className="card-body">
          <h4 className="mb-3">
            <span className="fas fa-question-circle mr-2" style={{ color: "#20c997" }} />
            7. Câu hỏi thường gặp
          </h4>
          {faqList.map((f, i) => {
            const isOpen = openFaq === i;
            return (
              <div key={i} style={{ border: "1px solid #eee", borderRadius: 8, marginBottom: 8, overflow: "hidden" }}>
                <div
                  onClick={() => toggleFaq(i)}
                  style={{ cursor: "pointer", padding: "11px 14px", background: isOpen ? "#e9fbf5" : "#f7f7f7", display: "flex", alignItems: "center", fontWeight: 600, fontSize: 13.5 }}
                >
                  <span className={isOpen ? "fas fa-minus-circle mr-2" : "fas fa-plus-circle mr-2"} style={{ color: "#20c997", fontSize: 13 }} />
                  {f.q}
                </div>
                {isOpen && (
                  <div style={{ padding: "12px 16px 14px 34px", fontSize: 13.5, lineHeight: 1.7, color: "#555" }}>
                    {f.a}
                  </div>
                )}
              </div>
            );
          })}
        </div>
      </div>
    </AkkhorLayout>
  );
}
